import { render, staticRenderFns } from "./HomepageColumn.vue?vue&type=template&id=37ef8e27"
import script from "./HomepageColumn.vue?vue&type=script&lang=js"
export * from "./HomepageColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports